/**
 * @desc 通过日期获取ebs汇率
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.EbsRateResponse>;
export function request(
  params: API.basics.exchangeRateFacadeImpl.getEbsRateByDate.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/basics/getEbsRateByDate`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
